import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { lightTheme as theme } from '../../theme';

const BaseButton = styled.button`
    height: ${({ $size }) => ($size === 'sm' ? '32px' : '40px')};
    border-radius: 999px;
    padding: ${({ $size }) => ($size === 'sm' ? '0 10px' : '0 16px')};
    border: 1px solid transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: ${({ $size }) => ($size === 'sm' ? '13px' : '14px')};
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }

    ${({ $variant }) =>
        $variant === 'secondary'
            ? css`
                  border-color: ${theme.colors.border};
                  background-color: ${theme.colors.paper};
                  color: ${theme.colors.text};

                  &:hover:not(:disabled) {
                      background-color: ${theme.colors.gray100};
                      border-color: ${theme.colors.gray300};
                  }
              `
            : css`
                  border: 0;
                  background-color: ${theme.colors.action};
                  color: #fff;
                  box-shadow: 0 4px 12px ${theme.colors.actionShadow};

                  &:hover:not(:disabled) {
                      transform: translateY(-2px);
                      box-shadow: 0 6px 16px ${theme.colors.actionShadow};
                  }
              `}
`;

const ButtonContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

function SharedButton({
    children,
    variant,
    size,
    startIcon,
    endIcon,
    ...props
}) {
    return (
        <BaseButton $variant={variant} $size={size} {...props}>
            <ButtonContent>
                {startIcon || null}
                {children}
                {endIcon || null}
            </ButtonContent>
        </BaseButton>
    );
}

SharedButton.propTypes = {
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary']),
    size: PropTypes.oneOf(['sm', 'md']),
    startIcon: PropTypes.node,
    endIcon: PropTypes.node,
};

SharedButton.defaultProps = {
    variant: 'primary',
    size: 'md',
    startIcon: null,
    endIcon: null,
};

export function PrimaryButton(props) {
    return <SharedButton {...props} variant='primary' />;
}

export function SecondaryButton(props) {
    return <SharedButton {...props} variant='secondary' />;
}

PrimaryButton.propTypes = SharedButton.propTypes;
SecondaryButton.propTypes = SharedButton.propTypes;

